module.exports = __webpack_public_path__ + "static/media/emily_shen.327602c5.png";